<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">まもりこサービス対応機器「人感センサー」購入のお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li class="current"><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->
        <section class="container">
            <div class="wrapper">
                <template v-if="!isLogin">
                    <h2 class="col5 section_title">
                        <strong>メールアドレス</strong>
                    </h2>
                    <div class="col7 wrap_pr_2col input_area">
                        <dl>
                            <dt>メールアドレス<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <input
                                    ref="customerEmail"
                                    v-model="customerEmail"
                                    type="email"
                                    placeholder="例）example@example.com"
                                    :class="[customerEmailInvalid ? 'invalid' : '']"
                                    required="required"
                                />
                            </dd>
                            <dd class="normal small color-red">
                                入力いただいたメールアドレス宛に購入時の領収書メールをお送りします。<br />
                                ドメイン指定など迷惑メール対策を行っている場合は以下を受信可能としてください。<br />
                                ・@portal.necolico.jp<br />
                                ・@necolico.co.jp
                            </dd>
                        </dl>
                        <!-- add_info -->
                        <hr class="thick" />
                    </div>
                </template>
                <h2 class="col5 section_title">
                    <strong>契約者情報</strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <dl>
                        <dt>お名前<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <input ref="customerName" v-model="customerName" type="text" placeholder="例）お名前" :class="[customerNameInvalid ? 'invalid' : '']" required="required" maxlength="26" />
                        </dd>
                    </dl>
                    <dl>
                        <dt>フリガナ</dt>
                        <dd>
                            <input
                                ref="customerKana"
                                v-model="customerKana"
                                type="text"
                                placeholder="例）オナマエ"
                                title="カタカナ、アルファベットで入力してください"
                                :class="[customerKanaInvalid ? 'invalid' : '']"
                                maxlength="500"
                                pattern="^[a-zA-Zァ-ヴ・ー\s]*$"
                            />
                        </dd>
                    </dl>
                    <dl>
                        <dt>郵便番号<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <input
                                ref="customerPostalCode"
                                :value="customerPostalCode"
                                @change="changedCustomerPostalCode"
                                type="tel"
                                placeholder="７桁。ハイフンなし"
                                :class="[customerPostalCodeInvalid ? 'invalid' : '']"
                                required="required"
                                minlength="7"
                                maxlength="7"
                                pattern="[0-9]{7}"
                                title="７桁。ハイフンなしで入力してください"
                            />
                            <a class="btn_round_s white" @click="searchCustomerAddress">検索</a>
                        </dd>
                    </dl>
                    <dl>
                        <dt>都道府県<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <div v-if="searchedCustomerAddressInfoEmpty" class="wrap_select">
                                <select ref="customerPrefecture" v-model="customerPrefecture" :class="[customerPrefectureInvalid ? 'invalid' : '']" required="required">
                                    <option value="">都道府県</option>
                                    <option v-for="(prefectureName, key) in prefectureNames" :key="key">
                                        {{ prefectureName }}
                                    </option>
                                </select>
                            </div>
                            <input
                                v-else
                                ref="customerPrefecture"
                                v-model="customerPrefecture"
                                type="text"
                                placeholder="例）東京都"
                                :class="[customerPrefectureInvalid ? 'invalid' : '']"
                                required="required"
                                disabled
                            />
                        </dd>
                    </dl>
                    <dl>
                        <dt>ご住所<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <input
                                v-if="searchedCustomerAddressInfoEmpty"
                                ref="customerCity"
                                v-model="customerCity"
                                type="text"
                                placeholder="市区町村 例）千代田区東神田"
                                :class="[customerCityInvalid ? 'invalid' : '']"
                                required="required"
                                maxlength="16"
                                pattern="^[、-龠]*$"
                            />
                            <input
                                v-else
                                ref="customerCity"
                                v-model="customerCity"
                                type="text"
                                placeholder="市区町村 例）千代田区東神田"
                                :class="[customerCityInvalid ? 'invalid' : '']"
                                required="required"
                                maxlength="16"
                                disabled
                            />
                            <input
                                ref="customerAddress"
                                v-model="customerAddress"
                                type="text"
                                placeholder="以降の住所 例）2-1-8 秋葉原クロスサイド6階"
                                :class="[customerAddressInvalid ? 'invalid' : '']"
                                required="required"
                                maxlength="35"
                            />
                        </dd>
                    </dl>
                    <dl>
                        <dt>電話番号<span class="normal small ml-05em">必須</span></dt>
                        <dd>
                            <input
                                ref="customerTel"
                                v-model="customerTel"
                                type="tel"
                                placeholder="例）08012345678 ハイフンなし"
                                title="最大１１桁。ハイフンなしで入力してください"
                                :class="[customerTelInvalid ? 'invalid' : '']"
                                required="required"
                                maxlength="11"
                                pattern="^[0-9]*$"
                            />
                        </dd>
                    </dl>
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title">
                    <strong>配送先情報</strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <a href="javascript:void(0)" class="link_checkbox" :class="[copyAddress ? '' : 'current']" @click="toggleCopyAddress">契約者と同じ住所に配送する</a>
                    <div v-show="!copyAddress" class="pt-2em">
                        <dl>
                            <dt>お名前<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <input
                                    ref="destinationName"
                                    v-model="destinationName"
                                    type="text"
                                    placeholder="例）お名前"
                                    :class="[destinationNameInvalid ? 'invalid' : '']"
                                    required="required"
                                    maxlength="26"
                                />
                            </dd>
                        </dl>
                        <dl>
                            <dt>フリガナ</dt>
                            <dd>
                                <input
                                    ref="destinationKana"
                                    v-model="destinationKana"
                                    type="text"
                                    placeholder="例）オナマエ"
                                    title="カタカナ、アルファベットで入力してください"
                                    :class="[destinationKanaInvalid ? 'invalid' : '']"
                                    maxlength="500"
                                    pattern="^[a-zA-Zァ-ヴ・ー\s]*$"
                                />
                            </dd>
                        </dl>
                        <dl>
                            <dt>郵便番号<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <input
                                    ref="destinationPostalCode"
                                    :value="destinationPostalCode"
                                    @change="changedDestinationPostalCode"
                                    type="tel"
                                    placeholder="７桁。ハイフンなし"
                                    :class="[destinationPostalCodeInvalid ? 'invalid' : '']"
                                    required="required"
                                    minlength="7"
                                    maxlength="7"
                                    pattern="[0-9]{7}"
                                    title="７桁。ハイフンなしで入力してください"
                                />
                                <a class="btn_round_s white" @click="searchDestinationAddress">検索</a>
                            </dd>
                        </dl>
                        <dl>
                            <dt>都道府県<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <div v-if="searchedDestinationAddressInfoEmpty" class="wrap_select">
                                    <select ref="destinationPrefecture" v-model="destinationPrefecture" :class="[destinationPrefectureInvalid ? 'invalid' : '']" required="required">
                                        <option value="">都道府県</option>
                                        <option v-for="(prefectureName, key) in prefectureNames" :key="key">
                                            {{ prefectureName }}
                                        </option>
                                    </select>
                                </div>
                                <input
                                    v-else
                                    ref="destinationPrefecture"
                                    v-model="destinationPrefecture"
                                    type="text"
                                    placeholder="例）東京都"
                                    :class="[destinationPrefectureInvalid ? 'invalid' : '']"
                                    required="required"
                                    disabled
                                />
                            </dd>
                        </dl>
                        <dl>
                            <dt>ご住所<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <input
                                    v-if="searchedDestinationAddressInfoEmpty"
                                    ref="destinationCity"
                                    v-model="destinationCity"
                                    type="text"
                                    placeholder="市区町村 例）千代田区東神田"
                                    :class="[destinationCityInvalid ? 'invalid' : '']"
                                    required="required"
                                    maxlength="16"
                                    pattern="^[、-龠]*$"
                                />
                                <input
                                    v-else
                                    ref="destinationCity"
                                    v-model="destinationCity"
                                    type="text"
                                    placeholder="市区町村 例）千代田区東神田"
                                    :class="[destinationCityInvalid ? 'invalid' : '']"
                                    required="required"
                                    maxlength="16"
                                    disabled
                                />
                                <input
                                    ref="destinationAddress"
                                    v-model="destinationAddress"
                                    type="text"
                                    placeholder="以降の住所 例）2-1-8 秋葉原クロスサイド6階"
                                    :class="[destinationAddressInvalid ? 'invalid' : '']"
                                    required="required"
                                    maxlength="35"
                                />
                            </dd>
                        </dl>
                        <dl>
                            <dt>電話番号<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <input
                                    ref="destinationTel"
                                    v-model="destinationTel"
                                    type="tel"
                                    placeholder="例）08012345678 ハイフンなし"
                                    title="最大１１桁。ハイフンなしで入力してください"
                                    :class="[destinationTelInvalid ? 'invalid' : '']"
                                    required="required"
                                    maxlength="11"
                                    pattern="^[0-9]*$"
                                />
                            </dd>
                        </dl>
                    </div>
                    <!-- add_info -->
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title"></h2>
                <div class="col7 wrap_pr_2col input_area">
                    <!-- <h3 class="mb-2em flex justify-between">
            <strong class="db strong big">お支払い情報</strong>
            <figure>
              <img src="../images/creditcard.png" width="198" alt="クレジットカードロゴイメージ" />
            </figure>
          </h3> -->
                    <p class="submit_btn">
                        <input type="submit" value="次へ" onsubmit="return false;" @click="confirm" />
                    </p>
                    <p class="submit_btn no-check no-arrow mt-3em">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                </div>
                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
import SiteConstants from "../../../../../../../Commons/SiteConstants";

export default {
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (from.name !== "CouponForm" && from.name !== "ContractConfirm") {
            next("/login");
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        // アカウントなし用に上書き（ログインユーザはnextのAPIで返却されるEmailが入っており画面上変更不可になっているので同じ内容で上書きされるだけ）
        to.params.customerEmail = this.customerEmail;
        to.params.customerName = this.customerName;
        to.params.customerKana = this.customerKana;
        to.params.customerPostalCode = this.customerPostalCode;
        to.params.customerPrefecture = this.customerPrefecture;
        to.params.customerCity = this.customerCity;
        to.params.customerAddress = this.customerAddress;
        to.params.customerTel = this.customerTel;
        to.params.copyAddress = this.copyAddress;
        to.params.destinationName = this.destinationName;
        to.params.destinationKana = this.destinationKana;
        to.params.destinationPostalCode = this.destinationPostalCode;
        to.params.destinationPrefecture = this.destinationPrefecture;
        to.params.destinationCity = this.destinationCity;
        to.params.destinationAddress = this.destinationAddress;
        to.params.destinationTel = this.destinationTel;
        to.params.searchedCustomerPostalCode = this.searchedCustomerPostalCode;
        to.params.searchedDestinationPostalCode = this.searchedDestinationPostalCode;
        to.params.searchedCustomerAddressInfoEmpty = this.searchedCustomerAddressInfoEmpty;
        to.params.searchedDestinationAddressInfoEmpty = this.searchedDestinationAddressInfoEmpty;

        to.params.cards = this.cards;
        to.params.card = this.card;

        to.params.isRequiredCredit = this.isRequiredCredit;
        to.params.planId = this.planId;
        to.params.product = this.product;
        to.params.code = this.code;
        to.params.promotionCode = this.promotionCode;

        next();
    },
    methods: {
        changedCustomerPostalCode: function (event) {
            // 郵便番号が変更された場合は郵便番号検索フラグ初期化
            this.customerPostalCode = event.target.value;
            this.searchedCustomerPostalCode = false;
        },
        changedDestinationPostalCode: function (event) {
            // 郵便番号が変更された場合は郵便番号検索フラグ初期化
            this.destinationPostalCode = event.target.value;
            this.searchedDestinationPostalCode = false;
        },
        searchCustomerAddress: async function () {
            // 郵便番号検索フラグ初期化
            this.searchedCustomerPostalCode = false;
            // 入力チェック (郵便番号)
            this.customerPostalCodeInvalid = true;
            // 郵便番号検索の結果が空かどうか。195-0076は2022年5月時点で空になっている。
            this.searchedCustomerAddressInfoEmpty = false;
            const input = this.$refs.customerPostalCode;
            if (input.validationMessage) {
                const msg = "入力項目に不備があります。確認してください。";
                this.$emit("openAlertModal", msg, null);
                return;
            }
            this.$emit("showSpinner", "処理中です");
            this.$axios(
                "GET",
                "/contractForm/address",
                {
                    postalCode: this.customerPostalCode
                },
                (res) => {
                    this.$emit("hideSpinner");
                    if (res.data.addressInfo) {
                        this.customerPrefecture = res.data.addressInfo.prefecture;
                        this.customerCity = res.data.addressInfo.city + res.data.addressInfo.address;
                        this.customerAddress = "";
                        this.searchedCustomerPostalCode = true;
                        this.customerPostalCodeInvalid = false;
                        if (!this.customerPrefecture || !this.customerCity) {
                            this.searchedCustomerAddressInfoEmpty = true;
                        }
                    }
                }
            );
        },
        searchDestinationAddress: async function () {
            // 郵便番号検索フラグ初期化
            this.searchedDestinationPostalCode = false;
            // 入力チェック (郵便番号)
            this.destinationPostalCodeInvalid = true;
            // 郵便番号検索の結果が空かどうか。195-0076は2022年5月時点で空になっている。
            this.searchedDestinationAddressInfoEmpty = false;
            const input = this.$refs.destinationPostalCode;
            if (input.validationMessage) {
                const msg = "入力項目に不備があります。確認してください。";
                this.$emit("openAlertModal", msg, null);
                return;
            }
            this.$emit("showSpinner", "処理中です");
            this.$axios(
                "GET",
                "/contractForm/address",
                {
                    postalCode: this.destinationPostalCode
                },
                (res) => {
                    this.$emit("hideSpinner");
                    if (res.data.addressInfo) {
                        this.destinationPrefecture = res.data.addressInfo.prefecture;
                        this.destinationCity = res.data.addressInfo.city + res.data.addressInfo.address;
                        this.destinationAddress = "";
                        this.searchedDestinationPostalCode = true;
                        this.destinationPostalCodeInvalid = false;
                        if (!this.destinationPrefecture || !this.destinationCity) {
                            this.searchedDestinationAddressInfoEmpty = true;
                        }
                    }
                }
            );
        },
        toggleCopyAddress: function () {
            this.copyAddress = !this.copyAddress;

            // 配送先を入力する場合は配送先の郵便番号検索が必須とする
            if (!this.copyAddress) {
                this.searchedDestinationPostalCode = false;
            }
        },
        confirm: async function () {
            // 子コンポーネントから値を取得
            try {
                // 入力チェック (契約者情報)
                let invalidElement = false;
                for (const key of ["customerName"]) {
                    this[`${key}Invalid`] = false;
                    const input = this.$refs[key];
                    // 最初に見つかった入力エラーのみハイライトさせ、それ以外のエラーはハイライトさせない
                    if (input.validationMessage || input.value.trim().length < 1) {
                        this[`${key}Invalid`] = true;
                        invalidElement = true;
                    }
                }
                const checkList = ["customerKana", "customerPostalCode", "customerPrefecture", "customerCity", "customerAddress", "customerTel"];
                if (!this.isLogin) {
                    checkList.push("customerEmail");
                }
                for (const key of checkList) {
                    this[`${key}Invalid`] = false;
                    const input = this.$refs[key];
                    // 最初に見つかった入力エラーのみハイライトさせ、それ以外のエラーはハイライトさせない
                    if (input.validationMessage) {
                        this[`${key}Invalid`] = true;
                        invalidElement = true;
                    }
                }
                // 配送先情報のハイライト解除が必要なため、ここではthrowさせない

                // 入力チェック (配送先情報)
                if (!this.copyAddress) {
                    for (const key of ["destinationName"]) {
                        this[`${key}Invalid`] = false;
                        const input = this.$refs[key];
                        if (input.validationMessage || input.value.trim().length < 1) {
                            this[`${key}Invalid`] = true;
                            invalidElement = true;
                        }
                    }
                    for (const key of ["destinationKana", "destinationPostalCode", "destinationPrefecture", "destinationCity", "destinationAddress", "destinationTel"]) {
                        this[`${key}Invalid`] = false;
                        const input = this.$refs[key];
                        if (input.validationMessage) {
                            this[`${key}Invalid`] = true;
                            invalidElement = true;
                        }
                    }
                }
                // 各項目の一通りのチェックを行った後、一つでもエラーがあれば「入力項目に不備があります」エラーを表示する
                if (invalidElement) {
                    throw new Error("入力項目に不備があります。確認してください。");
                }

                // 入力チェック(郵便番号検索)
                if (this.copyAddress && !this.searchedCustomerPostalCode) {
                    this["customerPostalCodeInvalid"] = true;
                    throw new Error("郵便番号入力欄にある検索ボタンを使用してください。");
                }
                if (!this.copyAddress && !this.searchedDestinationPostalCode) {
                    this["destinationPostalCodeInvalid"] = true;
                    throw new Error("配送先情報：郵便番号入力欄にある検索ボタンを使用してください。");
                }

                // 住所のアラビア数字チェック(半角全角問わず)
                const regex = new RegExp(/[0-9０-９]+/);
                if (!regex.test(this.customerAddress)) {
                    this["customerAddressInvalid"] = true;
                    throw new Error("丁目、番地、号は算用数字（アラビア数字）で入力してください。");
                }
                if (!this.copyAddress && !regex.test(this.destinationAddress)) {
                    this["destinationAddressInvalid"] = true;
                    throw new Error("配送先情報：丁目、番地、号は算用数字（アラビア数字）で入力してください。");
                }

                // カンマ入力チェック
                for (const key of ["customerAddress", "customerName"]) {
                    this[`${key}Invalid`] = false;
                    if (this[key].includes(",")) {
                        this[`${key}Invalid`] = true;
                        invalidElement = true;
                    }
                }
                if (!this.copyAddress) {
                    for (const key of ["destinationName", "destinationAddress"]) {
                        this[`${key}Invalid`] = false;
                        if (this[key].includes(",")) {
                            this[`${key}Invalid`] = true;
                            invalidElement = true;
                        }
                    }
                }
                if (invalidElement) {
                    throw new Error("カンマ「,」が含まれています。確認してください。");
                }
            } catch (err) {
                this.$emit("openAlertModal", err.message, null);
                return;
            }

            this.$router.push({
                name: "ContractConfirm"
            });
        },
        cancel: function () {
            this.$emit("openConfirmModal", "申込みをキャンセルしますか？", () => {
                // TOP画面へ遷移
                this.$router.push({
                    name: "Top",
                    params: {}
                });
            });
        }
    },
    data: function () {
        return {
            prefectureNames: [],
            customerName: "",
            customerNameInvalid: false,
            customerKana: "",
            customerKanaInvalid: false,
            customerPostalCode: "",
            customerPostalCodeInvalid: false,
            customerPrefecture: "",
            customerPrefectureInvalid: false,
            customerCity: "",
            customerCityInvalid: false,
            customerAddress: "",
            customerAddressInvalid: false,
            customerTel: "",
            customerTelInvalid: false,
            copyAddress: true,
            destinationName: "",
            destinationNameInvalid: false,
            destinationKana: "",
            destinationKanaInvalid: false,
            destinationPostalCode: "",
            destinationPostalCodeInvalid: false,
            destinationPrefecture: "",
            destinationPrefectureInvalid: false,
            destinationCity: "",
            destinationCityInvalid: false,
            destinationAddress: "",
            destinationAddressInvalid: false,
            destinationTel: "",
            destinationTelInvalid: false,
            searchedCustomerPostalCode: false,
            searchedDestinationPostalCode: false,
            searchedCustomerAddressInfoEmpty: false,
            searchedDestinationAddressInfoEmpty: false,
            cards: [],
            card: null,
            isRequiredCredit: true,
            product: {},
            customerEmail: "",
            customerEmailInvalid: false,
            isLogin: !document.isWithoutLogin
        };
    },
    created() {
        this.prefectureNames = SiteConstants.PrefectureNames;
        this.customerEmail = this.$route.params.customerEmail;

        // サービス料金
        this.product = this.$route.params.product;
        this.code = this.$route.params.code;
        this.promotionCode = this.$route.params.promotionCode;
        //  会員情報
        this.customerName = this.$route.params.customerName;
        this.customerKana = this.$route.params.customerKana;
        this.customerPostalCode = this.$route.params.customerPostalCode;
        this.customerPrefecture = this.$route.params.customerPrefecture ? this.$route.params.customerPrefecture : "";
        this.customerCity = this.$route.params.customerCity;
        this.customerAddress = this.$route.params.customerAddress;
        this.customerTel = this.$route.params.customerTel;
        // 配送先
        this.copyAddress = this.$route.params.copyAddress === undefined ? true : this.$route.params.copyAddress;
        this.destinationName = this.$route.params.destinationName;
        this.destinationKana = this.$route.params.destinationKana;
        this.destinationPostalCode = this.$route.params.destinationPostalCode;
        this.destinationPrefecture = this.$route.params.destinationPrefecture ? this.$route.params.destinationPrefecture : "";
        this.destinationCity = this.$route.params.destinationCity;
        this.destinationAddress = this.$route.params.destinationAddress;
        this.destinationTel = this.$route.params.destinationTel;
        // 既に郵便番号が設定されている場合は郵便番号検索は不要とする
        if (this.$route.params.copiedStripePostalCode && this.$route.params.customerPostalCode) {
            this.searchedCustomerPostalCode = true;
        } else {
            this.searchedCustomerPostalCode = this.$route.params.searchedCustomerPostalCode;
        }
        this.searchedDestinationPostalCode = this.$route.params.searchedDestinationPostalCode;
        this.searchedCustomerAddressInfoEmpty = this.$route.params.searchedCustomerAddressInfoEmpty;
        this.searchedDestinationAddressInfoEmpty = this.$route.params.searchedDestinationAddressInfoEmpty;
        // 支払情報
        this.cards = this.$route.params.cards;
        this.card = this.$route.params.card;
        // クレジットカード入力要否
        this.isRequiredCredit = this.$route.params.isRequiredCredit;
    }
};
</script>

<style scoped>
/* iosで青字になる  */
select {
    color: #000000;
}
</style>
